import { Suspense } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'

import { LoadingSpinner } from '@/shared-ui/LoadingSpinner'

import { ROUTES } from './paths'
import { routes } from './routes'

export function AppRouter() {
  const location = useLocation()

  return (
    <Suspense fallback={<LoadingSpinner fullscreen size="large" />}>
      <Routes location={location} key={location.pathname}>
        {routes.map(route => (
          <Route
            key={route.path}
            path={route.path}
            element={<route.component />}
          >
            {route.children?.map(child => (
              <Route
                key={child.path}
                path={child.path}
                element={<child.component />}
              />
            ))}
          </Route>
        ))}

        <Route path="/" element={<Navigate to={ROUTES.HOME} replace />} />
        <Route path="*" element={<Navigate to={ROUTES.NOT_FOUND} replace />} />
      </Routes>
    </Suspense>
  )
}
